import { ToastsState } from "./types";

export const initialState: ToastsState = {
    toasts: [],
};
